import { useEffect, useCallback } from 'react';

import { log } from '../utils';
import { useLoginStore, LoginState } from '../LoginStore';
import picsartAuth from '../../../../services/picsartAuth';

let refreshSetOnTabChange = false;

// The 'LoginArea' component can be mounted multiple times in different areas.
// In order to avoid calling 'refresh' successively multiple times which
// can lead to rate limit on the backend we track the initial refresh calls.
// We do not allow calling it in one tab if it's already been called.
let initialRefreshes = 0;

export function useInitialTokenRefresh() {
  const isLoggedIn = useLoginStore((state) => state.loginState === LoginState.In);

  const setLoginState = useLoginStore((state) => state.setLoginState);
  const refresh = useCallback(async () => {
    try {
      await picsartAuth.tokenRefresh();
      setLoginState(LoginState.In);
      return;
    } catch (err) {
      log(`Could not perform initial token refresh: ${err?.response?.data?.reason}`);
    }

    setLoginState(LoginState.Out);
  }, []);

  useEffect(() => {
    const canSetRefreshOnTabChange = !refreshSetOnTabChange && isLoggedIn;

    if (canSetRefreshOnTabChange) {
      const onVisibilityChange = () => {
        if (!document.hidden && isLoggedIn) {
          refresh();
        }
      };

      refreshSetOnTabChange = true;
      document.addEventListener('visibilitychange', onVisibilityChange);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (initialRefreshes < 1) {
      refresh();
      ++initialRefreshes;
    }

    return () => {
      --initialRefreshes;
    };
  }, []);
}
